import { FeaturesQuery } from '@/graphql/graphql';
import * as THREE from 'three';

export const computeMapOrigin = (features: FeaturesQuery['featuresByLayer'][number][]): THREE.Vector3 => {
  let minX = Infinity,
    minY = Infinity,
    minZ = Infinity;
  let maxX = -Infinity,
    maxY = -Infinity,
    maxZ = -Infinity;

  const scan = (c: any): void => {
    if (c[0] === undefined) return;
    return Array.isArray(c[0])
      ? c.forEach(scan)
      : ((minX = Math.min(minX, c[0])),
        (maxX = Math.max(maxX, c[0])),
        (minY = Math.min(minY, c[1])),
        (maxY = Math.max(maxY, c[1])),
        (minZ = Math.min(minZ, c[2] || 0)),
        (maxZ = Math.max(maxZ, c[2] || 0)));
  };

  features.forEach((f) => {
    if (f.geometry.coordinates) scan(f.geometry.coordinates);
    else if (f.geometry.geometries) f.geometry.geometries.forEach((g) => scan(g.coordinates));
  });
  return new THREE.Vector3((minX + maxX) / 2, (minY + maxY) / 2, (minZ + maxZ) / 2);
};
